import React, {useEffect, useState} from 'react';
import Jumbotron from "../components/Jumbotron";
import TablePeraturan from "../components/TablePeraturan";
import axios from "axios";

const PasalContent = () => {
    const [peraturan, setPeraturan] = useState([]);

    useEffect(() => {
        getDocuments().then(async (res) => {
            const response = await res.data;
            let peraturanTemp = [];
            response.forEach((image) => {
                if (image.directory === "clauses") {
                    peraturanTemp.push(image)
                }
            })
            setPeraturan(peraturanTemp)
        })
    }, []);

    const getDocuments = () => {
        return new Promise(async (resolve, reject) => {
            await axios.get('/api/file/clauses').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    }

    return (
        <div>
            <Jumbotron title='Peraturan'/>

            <section className='flex flex-col items-center justify-center pt-10 pb-20'>
                <div className='flex flex-col items-center justify-center pb-10'>
                    <p className='desktop:text-xl phone:text-lg'>Peraturan & Pasal yang berlaku</p>
                    <p></p>
                </div>
                <div className='desktop:w-[1000px]'>
                    <TablePeraturan data={peraturan}/>
                </div>
            </section>
        </div>
    );
};

export default PasalContent;